import client from './api-client';

export const getConfiguracionForm38 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form38: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosGestionImpicado = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestionImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const actualizarGestionDefensa = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/contacto', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaActGestionDefensa: response.data};
        } else {
            return {respuestaActGestionDefensa: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const getConfiguracionForm39 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form39: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboInstanciaPretensiones = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboInstanciasPretensiones: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboPosibilidadAcuerdo = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboPosibilidadesAcuerdo: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getPretensionesVigentesImplicado = async(query) => {
    try {
        
        const response = await client.get(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaPretensionesVigentes: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaPretensionesImplicados = async(query) => {
    try {
        
        const response = await client.get(`pretensiones/implicados?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaPretensionesImplicados: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaHistorialPretensionesImplicado = async(query) => {
    try {
        
        const response = await client.get(`pretensiones/historial?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaHistorialPretensionesImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getGrillaProvisionesImplicados = async(query) => {
    try {
        
        const response = await client.get(`provisiones/implicados?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaProvisionesImplicados: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaHistorialProvisionesImplicado = async(query) => {
    try {
        
        const response = await client.get(`provisiones/historial?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaHistorialProvisionesImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getCoberturaProvisiones = async(query) => {
    try {
        
        const response = await client.get(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaCoberturaProvisiones: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const actualizarPretensiones = async(body) => {
    try {
        const response = await client.post('pretensiones', body);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaActPretensiones: response.data};
        } else {
            return {respuestaActPretensiones: response.data};
        }

    } catch(error){
        throw error;
    }
}

export const actualizarProvisiones = async(body) => {
    try {
        const response = await client.post('provisiones', body);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaActProvisiones: response.data};
        } else {
            return {respuestaActProvisiones: response.data};
        }

    } catch(error){
        throw error;
    }
}

export const actualizarIndemnizacion = async(body) => {
    try {
        const response = await client.post('propuesta-indemnizacion', body);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaActProvisiones: response.data};
        } else {
            return {respuestaActProvisiones: response.data};
        }

    } catch(error){
        throw error;
    }
} 

export const getCasoImplicado = async(query) => {
    try {
        
        const response = await client.getCasoImplicado(`caso/implicado?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getParametros = async(query) => {
    try {
        
        const response = await client.getParametros(`parametros?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getListaImplicado = async(query) => {
    try {
        
        const response = await client.getImplicado(`caso/implicado/terceros?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaImplicados: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getComboMonedas = async(query) => {
    try {
        
        const response = await client.getMonedas(`monedas?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetHistorialProvisionesMoneda = async (query) => {
    try {
        const response = await client.getImplicado(`provisiones/historial?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}
export const serviceGetProvisionesImplicado = async (query) => {
    try {
        const response = await client.getImplicado(`provisiones/implicados?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}
export const getComboResponsabilidadAsegurado = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboResponsabilidadAsegurado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getAmparosCia = async(query) => {
    try {
        
        const response = await client.get(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                amparosCia: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}